module.exports = __webpack_public_path__ + "img/account.rate.daily.18fb6fa0.png";